import script from "./TextNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TextNav.vue?vue&type=script&setup=true&lang=js"

import "./TextNav.vue?vue&type=style&index=0&id=fdf64226&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdf64226"]])

export default __exports__